import evidSymbol from '../../Utils/img/evid-symbol.svg';

import styles from './BrandMark.module.scss';

// The product's name: the EVID symbol and the word in live text (OQ-203, ui/app-components.md § Shared UI components).
type BrandMarkProps = { size?: 'lg' };

export const BrandMark = ({ size }: BrandMarkProps) => (
  <span className={size === 'lg' ? `${styles.brand} ${styles.lg}` : styles.brand}>
    <img src={evidSymbol} alt='' className={styles.symbol} />
    <span className={styles.word}>EVID</span>
  </span>
);
